import script from "./SimpleView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimpleView.vue?vue&type=script&lang=ts&setup=true"

import "./SimpleView.vue?vue&type=style&index=0&id=59fb575c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59fb575c"]])

export default __exports__